// HTMX
import 'htmx.org';

// Bootstrap
import 'bootstrap';

// Font Awesome
import { dom } from '@fortawesome/fontawesome-svg-core'
dom.watch();

// Fundderworks Global Styles and Scripts
import '@scss/_global/index.scss';
import { init as initValidation} from './validation.js';
import { init as initNavigation} from './navigation.js';
import { init as initAuthentication} from './authentication.js';
import { init as initButtons} from './buttons.js';
import { init as initWhatIsThisModals} from './whatIsThis.js';
import './_icons.js';

document.addEventListener("DOMContentLoaded", () => {
    initValidation();
    initNavigation();
    initButtons();
    initAuthentication();
    initWhatIsThisModals();
});